"use strict";
exports.__esModule = true;
var currencies_1 = require("../../currencies");
var ETH = (0, currencies_1.getCryptoCurrencyById)("ethereum");
var remap = function (pair) {
    if (pair.from.ticker === "WETH")
        return {
            from: ETH,
            to: pair.to
        };
    if (pair.to.ticker === "WETH")
        return {
            from: pair.from,
            to: ETH
        };
    return pair;
};
var mod = {
    aliasPair: remap,
    resolveTrackingPair: remap
};
exports["default"] = mod;
//# sourceMappingURL=weth.js.map